import CategoryTitle from '../../Basic/CategoryTitle/CategoryTitle.mjs';
import HorizontalCarousel from '../../UIElements/HorizontalCarousel/HorizontalCarousel.mjs';
import styled from 'styled-components';

const StyledHorizontalCarousel = styled(HorizontalCarousel) `
  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    padding: 0 3.75rem;
  }
`;
const StyledTalentsCategoryLink = styled(CategoryTitle) `
  margin-left: 1rem;

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    margin-left: 3.75rem;
  }
`;

export { StyledHorizontalCarousel, StyledTalentsCategoryLink };
//# sourceMappingURL=Talents.styles.mjs.map
